<template>
  <div id="app">
    <component :is="layout">
      <keep-alive :include="['GridView']">
        <router-view :key="$route.fullPath" />
      </keep-alive>
      <AppLoadingState v-if="isLoading" />
    </component>
  </div>
</template>

<script>
export default {
  components: {
    AppLoadingState: () => import('@/components/ui/AppLoadingState'),
    DefaultLayout: () => import('@/components/layout/DefaultLayout'),
    AuthenticationLayout: () =>
      import('@/components/layout/AuthenticationLayout'),
    AdminLayout: () => import('@/components/layout/AdminLayout')
  },
  computed: {
    isLoading: function () {
      return this.$store.getters['loader/isLoading']
    },
    layout: function () {
      return `${this.$route.meta.layout || 'Default'}Layout`
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Nunito:300,400,600,700,800,900');

html,
body,
#app {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

#app {
  font-family: $font-stack;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $neutral-medium;
}
</style>
